import React from 'react'
import {ProfileDetails} from './cards/ProfileDetails'
import {SignInMethod} from './cards/SignInMethod'
export function Settings() {
  return (
    <>
      <ProfileDetails />
      <SignInMethod />
    </>
  )
}
